import { render, staticRenderFns } from "./CapturaDocumentos.vue?vue&type=template&id=c0fee10e&scoped=true&"
import script from "./CapturaDocumentos.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentos.vue?vue&type=style&index=0&id=c0fee10e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fee10e",
  null
  
)

export default component.exports